import React, { FC } from 'react';
import { List } from '@mui/material';
import { IMenuItem } from '../../../lib/interfaces/MenuItem';
import SidebarMenuListItem from './SidebarMenuListItem';

type SidebarMenuListProps = {
	items: IMenuItem[];
};

const SidebarMenuList: FC<SidebarMenuListProps> = ({ items }) => (
	<List sx={{ padding: '10px 10px 0 10px' }}>
		{items.map((item) => (
			<SidebarMenuListItem item={item} key={item.slug} />
		))}
	</List>
);

export default SidebarMenuList;
